export default __webpack_public_path__ + "5b4cef470e7e7f328da9feae137bc98b.png";